export default class Arc {
    constructor(breakpoints = {
        md: 768,
        xl: 1280
    }) {
        this.breakpoints = breakpoints
        $(window).on('resize orientationchange', this.draw.bind(this))
        this.draw()
    }

    draw() {
        let arr = [400, 60, 10]
        if (window.matchMedia(`(min-width: ${this.breakpoints.md}px)`).matches) {
            arr = [400, 90, 15]
        } else if (window.matchMedia(`(min-width: ${this.breakpoints.xl}px)`).matches) {
            arr = [400, 170, 20]
        }

        let canvas = document.querySelector('#canvas_arc')
        canvas.width = window.innerWidth * 2
        canvas.height = 120
        let ctx = canvas.getContext('2d')
        ctx.beginPath()
        ctx.moveTo(0, 50)
        for (var i = 1; i < arr[0]; i += 0.1) {
            let x = i * arr[1];
            var y = Math.sin(i) * arr[2] + 50;
            ctx.lineTo(x, y)
        }
        ctx.lineTo(window.innerWidth, 120)
        ctx.lineTo(0, 120)
        ctx.lineTo(0, 50)
        ctx.closePath()
        ctx.strokeStyle = "#f9f9f9"
        ctx.stroke()
        ctx.fillStyle = "#f9f9f9";
        ctx.fill();
    }
}